import { render, staticRenderFns } from "./ClockAndDate.vue?vue&type=template&id=045f2a32&"
import script from "./ClockAndDate.vue?vue&type=script&lang=js&"
export * from "./ClockAndDate.vue?vue&type=script&lang=js&"
import style0 from "./ClockAndDate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045f2a32')) {
      api.createRecord('045f2a32', component.options)
    } else {
      api.reload('045f2a32', component.options)
    }
    module.hot.accept("./ClockAndDate.vue?vue&type=template&id=045f2a32&", function () {
      api.rerender('045f2a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClockAndDate.vue"
export default component.exports